<script lang="ts">
    import { getContext } from "svelte"
    import Loader from "../../../lib/Loader.svelte"
    import { Classifier } from "../../../lib/golang-models/maindb"
    import Form from "../../../widgets/Form.svelte"
    import Table from "../../../widgets/Table.svelte"
    import TableSorter from "../../../widgets/TableSorter.svelte"
    import Thumb from "../../../widgets/Thumb.svelte"
    import PageFooter from "../../elements/PageFooter.svelte"

    const i18n: any = getContext("i18n"),
        modal: any = getContext("modal")

    var formMode: "none" | "edit" | "add" = "none",
        formRecord: Classifier = null

    let audioFile: FileList | null = null
    let isUploadingAudio = false
    let hasBaitAudio = false
    let audioDuration = 0
    let uploadError = ""

    const handleCheckBaitAudio = async (id: number) => {
        if (id <= 0) return
        uploadError = ""
        try {
            const res = await modal.get(`classifier/${id}/has-bait-audio`)
            if (res.status === 200) {
                const data = await res.json()
                hasBaitAudio = data.exists
            }
        } catch (e) {
            console.error("Erro ao verificar áudio:", e)
        }
    }

    const handleUploadAudio = async () => {
        if (!audioFile || audioFile.length === 0 || !formRecord?.Id) return
        
        isUploadingAudio = true
        uploadError = ""
        
        try {
            const formData = new FormData()
            formData.append("audio", audioFile[0])
            
            const res = await fetch(`classifier/${formRecord.Id}/upload-bait-audio`, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            
            const data = await res.json()
            
            if (res.status === 200) {
                hasBaitAudio = true
                formRecord.BaitAudioPath = data.filename
                audioDuration = data.duration || 0
                audioFile = null
                uploadError = ""
            } else {
                uploadError = data.error || "Erro ao fazer upload do áudio"
                if (data.info) {
                    uploadError += ` (atual: ${data.info.sampleRate}Hz, ${data.info.numChannels} canal(is), ${data.info.bitsPerSample} bits)`
                }
            }
        } catch (e) {
            console.error("Erro ao fazer upload:", e)
            uploadError = "Erro de conexão ao fazer upload"
        } finally {
            isUploadingAudio = false
        }
    }

    const handleRemoveAudio = async () => {
        if (!formRecord?.Id) return
        if (!confirm("Tem certeza que deseja remover o áudio de isca?")) return
        
        try {
            const res = await modal.post(`classifier/${formRecord.Id}/remove-bait-audio`, {})
            if (res.status === 200) {
                hasBaitAudio = false
                formRecord.BaitAudioEnabled = false
                formRecord.BaitAudioPath = ""
                audioDuration = 0
                uploadError = ""
            }
        } catch (e) {
            console.error("Erro ao remover áudio:", e)
        }
    }

    const formatDuration = (ms: number): string => {
        if (ms < 1000) return `${ms}ms`
        return `${(ms / 1000).toFixed(1)}s`
    }
</script>

<Loader endpoint="classifier/list" let:data let:reload>
    {#if formMode == "none"}
        <!-- List -->
        <Table>
            <tr slot="head">
                <th>ID <TableSorter /></th>
                <th>{i18n.translate("dict.name")} <TableSorter /></th>
                <th>{i18n.translate("field.active")} </th>
            </tr>

            {#each data as record}
                <tr>
                    <td>{record.Id}</td>
                    <td
                        ><a
                            href="#edit"
                            on:click|preventDefault={() => {
                                formRecord = { ...record }
                                formMode = "edit"
                                hasBaitAudio = false
                                handleCheckBaitAudio(record.Id)
                            }}>{record.Name}</a
                        ></td
                    >
                    <td><Thumb value={record.IsEnabled} /></td>
                    <td>
                        <a
                            href="#edit"
                            on:click|preventDefault={() => {
                                formRecord = { ...record }
                                formMode = "edit"
                                hasBaitAudio = false
                                handleCheckBaitAudio(record.Id)
                            }}><i class="fa-solid fa-pencil" /></a
                        >
                        <a href="#remove" on:click|preventDefault={() => confirm(i18n.translate("question.remove-item", { item: record.Name })) && modal.post("classifier/remove/" + record.Id).then((r) => r.status == 200 && reload())}><i class="fa-solid fa-trash" /></a>
                    </td>
                </tr>
            {/each}
        </Table>

        <PageFooter>
            <expander />
            <button on:click={() => reload()}><i class="fa-solid fa-refresh" /> {i18n.translate("action.refresh")}</button>
            <button
                on:click={() => {
                    formRecord = new Classifier()
                    formMode = "add"
                }}><i class="fa-solid fa-plus" /> {i18n.translate("action.add")} {i18n.translate("dict.classifier")}</button
            >
        </PageFooter>
    {:else}
        <Form
            submit={() =>
                modal.post(`classifier/save`, formRecord).then((res) => {
                    if (res.status != 200) return
                    formMode = "none"
                    reload()
                })}
        >
            <svelte:fragment slot="title">{i18n.translate("action." + formMode)} {i18n.translate("dict.classifier")}</svelte:fragment>

            {#if formMode == "edit"}
                <label>
                    ID
                    <input disabled value={formRecord.Id} />
                </label>
            {/if}

            <label>
                {i18n.translate("dict.name")}*
                <input type="text" bind:value={formRecord.Name} required />
            </label>

            <!-- =============== PRÉ-ATENDIMENTO =============== -->
            <fieldset>
                <legend><i class="fa-solid fa-phone-volume" /> Pré-Atendimento (antes do 200 OK)</legend>
                <p class="help-text">
                    Analisa o áudio durante o early media (183) para detectar mensagens de operadora ou caixa postal 
                    <strong>antes</strong> da chamada ser atendida.
                </p>

            <label class="checkbox">
                <input type="checkbox" autocomplete="off" bind:checked={formRecord.CheckBeforeAnswer} />
                    Ativar análise pré-atendimento
            </label>

            <label class="checkbox">
                <input type="checkbox" autocomplete="off" disabled={!formRecord.CheckBeforeAnswer} bind:checked={formRecord.PreMessageHangup} />
                    Derrubar chamada ao detectar mensagem
                    <small>Ex: "O número chamado está desligado ou fora da área de cobertura"</small>
                </label>

                <label>
                    Threshold de detecção de fala
                    <input type="number" min="0.001" max="0.05" step="0.001" disabled={!formRecord.CheckBeforeAnswer} bind:value={formRecord.PreMessageThreshold} required />
                    <small>
                        Sensibilidade da detecção de voz vs tom de chamada. 
                        <strong>Menor = mais sensível</strong> (detecta mais, pode ter falsos positivos). 
                        <strong>Maior = menos sensível</strong> (menos falsos positivos).
                        <br/>Ex: 0.003 (muito sensível) | 0.005 (padrão) | 0.01 (pouco sensível)
                    </small>
            </label>

                <label>
                    Tempo mínimo de fala para confirmar (ms)
                    <input type="number" min="100" max="3000" disabled={!formRecord.CheckBeforeAnswer} bind:value={formRecord.ConfirmSpeechTime} required />
                    <small>
                        Tempo mínimo de fala contínua antes de confirmar como mensagem.
                        Evita falsos positivos com ruídos curtos.
                        <br/>Ex: 300ms (rápido) | 500ms (padrão) | 1000ms (conservador)
                    </small>
                </label>
            </fieldset>

            <!-- =============== PÓS-ATENDIMENTO (AMD) =============== -->
            <fieldset>
                <legend><i class="fa-solid fa-voicemail" /> Pós-Atendimento - AMD (após 200 OK)</legend>
                <p class="help-text">
                    Analisa o áudio <strong>após</strong> o atendimento (200 OK) para detectar caixa postal.
                    Funciona como o AMD (Answering Machine Detection) do Asterisk.
                </p>

            <label class="checkbox">
                <input type="checkbox" autocomplete="off" bind:checked={formRecord.CheckAfterAnswer} />
                    Ativar análise pós-atendimento (AMD)
            </label>

            <label class="checkbox">
                <input type="checkbox" autocomplete="off" disabled={!formRecord.CheckAfterAnswer} bind:checked={formRecord.NoVoiceDetectedHangup} />
                    Derrubar chamada se detectar caixa postal
                    <small>Se desativado, apenas marca no CDR sem derrubar</small>
                </label>

                <label class="checkbox">
                    <input type="checkbox" autocomplete="off" disabled={!formRecord.CheckAfterAnswer} bind:checked={formRecord.WaitClassificationBeforeAnswer} />
                    Classificar totalmente antes de devolver atendimento
                    <small>
                        <strong>Segura o 200 OK</strong> até confirmar voz humana. 
                        Se detectar caixa postal, envia <strong>status de erro</strong> para ponta A (não o 200 OK).
                        Ideal para discadores que não devem conectar ligações improdutivas à PA.
                    </small>
                </label>

                <label class="checkbox">
                    <input type="checkbox" autocomplete="off" disabled={!formRecord.CheckAfterAnswer || !formRecord.WaitClassificationBeforeAnswer} bind:checked={formRecord.SendOnly180DuringClassification} />
                    Enviar somente 180 Ringing durante a classificação
                    <small>
                        Remove o <strong>183 Session Progress + SDP</strong> (early media) enviado para ponta A durante a análise.
                        A ponta A recebe apenas <strong>180 Ringing</strong> até o 200 OK ser liberado.
                        Evita que o áudio de caixa postal chegue ao discador/PA antes da classificação.
                    </small>
            </label>

            <label>
                    Duração mínima de fala (ms)
                    <input type="number" min="10" max="1000" disabled={!formRecord.CheckAfterAnswer} bind:value={formRecord.GreetingDuration} required />
                    <small>
                        Tempo mínimo de fala para ser considerado válido (evita ruídos).
                        <br/>Ex: 50ms (padrão) - Um "alô" dura ~200-500ms
                    </small>
            </label>

            <label>
                    Duração máxima de fala - AMD (ms)
                    <input type="number" min="500" max="5000" disabled={!formRecord.CheckAfterAnswer} bind:value={formRecord.MaxGreetingDuration} required />
                    <small>
                        Fala maior que isso = caixa postal. Fala menor + silêncio = humano.
                        <br/>Ex: 1500ms (padrão Asterisk) - Mensagem de caixa postal dura 5-20s, "alô" dura ~300ms
                    </small>
            </label>

            <label>
                    Timeout de silêncio inicial (ms)
                    <input type="number" min={formRecord.GreetingDuration} max="6000" disabled={!formRecord.CheckAfterAnswer} bind:value={formRecord.GreetingTimeout} required />
                    <small>
                        Se não detectar fala após esse tempo do 200 OK = caixa postal silenciosa.
                        <br/>Ex: 2000ms (padrão) - Humano fala "alô" em ~500ms após atender
                    </small>
                </label>

                <label class="checkbox">
                    <input
                        type="checkbox"
                        autocomplete="off"
                        disabled={!formRecord.CheckAfterAnswer}
                        bind:checked={formRecord.PostAnswerSafetyDelayEnabled}
                    />
                    Habilitar tempo inicial de segurança após o atendimento
                    <small>
                        Ao atender (200 OK), o pós-classificador <strong>ignora todos os pacotes</strong> por esse período antes de iniciar as análises.
                        Útil para cenários onde a caixa postal atende com 200 OK e emite um <strong>beep</strong> que pode ser confundido com um "alô".
                    </small>
                </label>

                <label>
                    Tempo inicial de segurança após o atendimento (ms)
                    <input
                        type="number"
                        min="0"
                        max="5000"
                        step="10"
                        disabled={!formRecord.CheckAfterAnswer || !formRecord.PostAnswerSafetyDelayEnabled}
                        bind:value={formRecord.PostAnswerSafetyDelayMs}
                        required
                    />
                    <small>
                        Ex: 300ms → após o 200 OK, o AMD espera 300ms e só então começa a contar os demais timeouts a partir desse momento.
                    </small>
                </label>

                <label>
                    <strong style="color: #dc3545;">⏱️ Timeout ABSOLUTO de classificação (ms)</strong>
                    <input type="number" min="2000" max="15000" disabled={!formRecord.CheckAfterAnswer} bind:value={formRecord.ClassificationTimeout} required />
                    <small style="color: #dc3545;">
                        <strong>CRÍTICO:</strong> Tempo máximo para classificar. Ao atingir esse tempo, o RTP Proxy emite <strong>TIMEOUT</strong>
                        e o Softswitch aplica a <strong>política segura</strong> (equivalente a “não detectou voz”), evitando passar ligações improdutivas.
                        <br/>Previne que chamadas fiquem presas indefinidamente em loop (ex: SILENCE ↔ SPEECH_PRE).
                        <br/>Ex: 5000ms (padrão) | 3000ms (agressivo) | 8000ms (conservador)
                        <br/><strong>Obs:</strong> O efeito final depende das flags “Derrubar chamada se detectar caixa postal” e “Classificar totalmente antes de devolver atendimento”.
                    </small>
                </label>
            </fieldset>

            <!-- =============== ÁUDIO ISCA =============== -->
            <fieldset>
                <legend><i class="fa-solid fa-volume-high" /> Áudio Isca (Bait Audio)</legend>
                <p class="help-text">
                    Injeta um áudio (ex: "alô") na ponta B assim que a chamada é atendida (200 OK), 
                    <strong>enquanto o AMD ainda está classificando</strong>. Isso mantém a pessoa na linha
                    e provoca uma resposta mais natural.
                    <br/><strong>Importante:</strong> Funciona apenas com "Classificar totalmente antes de devolver atendimento" ativado.
                </p>

                {#if formMode === "edit" && formRecord.Id}
                    <div class="audio-upload-section">
                        {#if hasBaitAudio || formRecord.BaitAudioPath}
                            <div class="audio-status success">
                                <i class="fa-solid fa-check-circle" /> 
                                Áudio de isca carregado
                                {#if audioDuration > 0}
                                    <span class="audio-duration">({formatDuration(audioDuration)})</span>
                                {/if}
                                <button type="button" class="btn-small danger" on:click={handleRemoveAudio}>
                                    <i class="fa-solid fa-trash" /> Remover
                                </button>
                            </div>
                        {:else}
                            <div class="audio-status warning">
                                <i class="fa-solid fa-exclamation-triangle" /> Nenhum áudio carregado
                            </div>
                        {/if}

                        {#if uploadError}
                            <div class="audio-status error">
                                <i class="fa-solid fa-times-circle" /> {uploadError}
                            </div>
                        {/if}

                        <label>
                            Arquivo de áudio (WAV - 8kHz, mono)
                            <input 
                                type="file" 
                                accept=".wav,audio/wav" 
                                bind:files={audioFile}
                                disabled={isUploadingAudio}
                            />
                            <small>
                                Formatos suportados: PCM 8-bit, PCM 16-bit, G.711 A-Law ou G.711 µ-Law
                                <br/>
                                <strong>FFmpeg:</strong>
                                <br/>• PCM 16-bit: <code>ffmpeg -i audio.mp3 -ar 8000 -ac 1 -acodec pcm_s16le audio.wav</code>
                                <br/>• G.711 A-Law: <code>ffmpeg -i audio.mp3 -ar 8000 -ac 1 -acodec pcm_alaw audio.wav</code>
                            </small>
                        </label>
                        
                        {#if audioFile && audioFile.length > 0}
                            <button 
                                type="button" 
                                class="primary" 
                                on:click={handleUploadAudio}
                                disabled={isUploadingAudio}
                            >
                                {#if isUploadingAudio}
                                    <i class="fa-solid fa-spinner fa-spin" /> Enviando...
                                {:else}
                                    <i class="fa-solid fa-upload" /> Fazer upload
                                {/if}
                            </button>
                        {/if}
                    </div>
                {:else if formMode === "add"}
                    <p class="info-text">
                        <i class="fa-solid fa-info-circle" /> 
                        Salve o classificador primeiro para poder fazer upload do áudio de isca.
                    </p>
                {/if}

                <label class="checkbox">
                    <input 
                        type="checkbox" 
                        autocomplete="off" 
                        disabled={!formRecord.CheckAfterAnswer || !formRecord.WaitClassificationBeforeAnswer || (!hasBaitAudio && !formRecord.BaitAudioPath)} 
                        bind:checked={formRecord.BaitAudioEnabled} 
                    />
                    Ativar áudio de isca
                    <small>
                        O áudio será enviado para a ponta B logo após o 200 OK, antes de confirmar voz humana.
                        <br/>Requer: "Classificar totalmente antes de devolver atendimento" + áudio carregado.
                    </small>
                </label>
            </fieldset>

            <!-- =============== CONFIGURAÇÕES GERAIS =============== -->
            <fieldset>
                <legend><i class="fa-solid fa-sliders" /> Configurações Gerais</legend>

                <label>
                    Margem de transição de fala (ms)
                <input type="number" min="10" max="1000" bind:value={formRecord.SpeechMarginTime} required />
                    <small>
                        Tempo de margem para confirmar início/fim de fala (debounce).
                        Evita detectar pausas curtas como fim de fala.
                        <br/>Ex: 100ms (padrão) - Pausas naturais na fala duram ~50-150ms
                    </small>
            </label>

            <label>
                    Sensibilidade de detecção de voz (amplitude)
                    <input type="number" min="50" max="500" bind:value={formRecord.SpeechAmplitudeThreshold} required />
                    <small>
                        Amplitude mínima do áudio para ser considerado fala. 
                        <strong>Menor = mais sensível</strong> (detecta falas baixas).
                        <strong>Maior = menos sensível</strong> (ignora ruídos).
                        <br/>Ex: 100 (muito sensível) | 200 (padrão) | 300 (pouco sensível)
                    </small>
            </label>

            <label>
                    Status de desligamento (pré-atendimento)
                <input type="number" min="400" max="699" bind:value={formRecord.HangupStatus} required />
                    <small>
                        Código SIP retornado ao derrubar no pré-atendimento.
                        <br/>Ex: 487 (Request Terminated) | 480 (Temporarily Unavailable) | 486 (Busy Here)
                    </small>
            </label>

            <label class="checkbox">
                <input type="checkbox" autocomplete="off" bind:checked={formRecord.IsEnabled} />
                {i18n.translate("field.active")}
            </label>
            </fieldset>

            <svelte:fragment slot="footer">
                <PageFooter>
                    <expander />
                    <button type="button" class="cancel" on:click={() => (formMode = "none")}><i class="fa-solid fa-pencil" /> {i18n.translate("action.cancel")}</button>
                    <button type="submit" class="primary"><i class="fa-solid fa-floppy-disk" /> {i18n.translate("dict.save")}</button>
                </PageFooter>
            </svelte:fragment>
        </Form>
    {/if}
</Loader>

<style>
    fieldset {
        border: 1px solid var(--border-color, #ddd);
        border-radius: 8px;
        padding: 1rem;
        margin: 1rem 0;
        background: var(--bg-secondary, #f9f9f9);
    }
    fieldset legend {
        font-weight: 600;
        padding: 0 0.5rem;
        color: var(--primary-color, #333);
    }
    fieldset legend i {
        margin-right: 0.5rem;
    }
    .help-text {
        font-size: 0.85rem;
        color: var(--text-muted, #666);
        margin: 0 0 1rem 0;
        padding: 0.5rem;
        background: var(--bg-tertiary, #f0f0f0);
        border-radius: 4px;
        border-left: 3px solid var(--primary-color, #007bff);
    }
    .info-text {
        font-size: 0.85rem;
        color: var(--text-muted, #666);
        margin: 0.5rem 0;
        padding: 0.5rem;
        background: var(--bg-tertiary, #e8f4fc);
        border-radius: 4px;
        border-left: 3px solid #17a2b8;
    }
    label small {
        display: block;
        font-size: 0.8rem;
        color: var(--text-muted, #888);
        margin-top: 0.25rem;
        line-height: 1.4;
    }
    .audio-upload-section {
        margin: 1rem 0;
        padding: 1rem;
        background: var(--bg-tertiary, #f5f5f5);
        border-radius: 6px;
    }
    .audio-status {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.5rem 0.75rem;
        border-radius: 4px;
        margin-bottom: 1rem;
        font-size: 0.9rem;
    }
    .audio-status.success {
        background: #d4edda;
        color: #155724;
    }
    .audio-status.warning {
        background: #fff3cd;
        color: #856404;
    }
    .audio-status.error {
        background: #f8d7da;
        color: #721c24;
    }
    .audio-status i {
        font-size: 1.1rem;
    }
    .audio-duration {
        font-size: 0.85rem;
        opacity: 0.8;
    }
    .btn-small {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        margin-left: auto;
    }
    .btn-small.danger {
        background: #dc3545;
        color: white;
    }
    .btn-small.danger:hover {
        background: #c82333;
    }
    code {
        font-family: monospace;
        background: rgba(0,0,0,0.1);
        padding: 0.1rem 0.3rem;
        border-radius: 3px;
        font-size: 0.75rem;
    }
</style>
